import { useTranslation } from "react-i18next";
import Typography from "@common/components/Typography";
import MeetingLiveChart from "@common/components/LiveCharts/MeetingLiveChart";
import {
  inThePast,
  isParticipantConnected,
  isParticipantManaged,
} from "@common/utils/meetings";
import { getColorGraph, getGraphTitle } from "../const";
import { ConferenceParticipant } from "@services/meetings/types";
import { Device } from "@services/devices/types";
import { GraphType } from "@services/monitoring/types";

type CardContentProps = {
  device?: Device;
  participant: ConferenceParticipant;
  meeting: { start?: number; end?: number; meetingId?: number };
  graphType: GraphType;
};

const CardContent = (props: CardContentProps) => {
  const { device, participant, meeting, graphType } = props;

  const { t } = useTranslation();

  const startDate = meeting.start;
  const endDate =
    (meeting.end && meeting.end > new Date().getTime()) ||
    meeting.end === undefined
      ? new Date().getTime()
      : meeting.end;

  const breadcrumbPage = meeting.meetingId?.toString() ?? "Meeting";

  if (!isParticipantManaged(participant)) {
    return (
      <Typography>{t("This device is not managed by Symphony")}</Typography>
    );
  }

  if (isParticipantConnected(participant) || inThePast(meeting.end)) {
    return (
      <MeetingLiveChart
        start={startDate}
        end={endDate}
        title={getGraphTitle(graphType, t)}
        graphType={graphType}
        color={getColorGraph(graphType)}
        device={device}
        breadcrumbPage={breadcrumbPage}
      />
    );
  }

  return <Typography>{t("The device is not in this call")}</Typography>;
};

export default CardContent;
